import {useCallback,useEffect,useRef,useState} from 'react';
import type {User} from 'firebase/auth';
import type {Journal} from '../domain';
import {accountRequest} from './account-client';
import type {AccountStats} from './account-client';
export function useAccountStats(user:User|null,syncStatus:string,journal:Journal,visible:boolean){
 const [stats,setStats]=useState<AccountStats|null>(null),[retry,setRetry]=useState(0),[timezoneReady,setTimezoneReady]=useState(false);
 const loaded=useRef<{signature:string;at:number;retry:number}|null>(null);
 const signature=JSON.stringify([journal.saved,Object.entries(journal.completed).sort()]);
 const refresh=useCallback(()=>setRetry(n=>n+1),[]);
 useEffect(()=>{
  if(!user){loaded.current=null;setStats(null);return;}
  if(!timezoneReady||syncStatus==='connecting'||syncStatus==='syncing')return;
  const previous=loaded.current;
  if(previous?.signature===signature&&(!visible||(previous.retry===retry&&Date.now()-previous.at<60000)))return;
  let active=true;
  const timer=setTimeout(()=>{accountRequest(user,'/api/me/stats').then(data=>{if(active){setStats(data);loaded.current={signature,at:Date.now(),retry};}}).catch(()=>{});},250);
  return()=>{active=false;clearTimeout(timer);};
 },[user,syncStatus,signature,visible,retry,timezoneReady]);
 useEffect(()=>{if(!user||!visible)return;const timer=setInterval(refresh,60000);return()=>clearInterval(timer);},[user,visible,refresh]);
 useEffect(()=>{if(!user)return;let active=true;accountRequest(user,'/api/me/preferences',{timezone:Intl.DateTimeFormat().resolvedOptions().timeZone||'UTC'}).catch(()=>{}).finally(()=>{if(active)setTimezoneReady(true);});return()=>{active=false;};},[user]);
 return {stats,refresh};
}
